import { Button, Descriptions, Flex, Form, Modal } from 'antd'
import {
  useModalAddUserStore,
  useMap,
} from 'src/pages/budget/budgetTeams/hooks'
import {
  closeModalAddUser,
  submitAddUser,
} from 'src/pages/budget/budgetTeams/model'
import { BUDGET_STEPS, labelStyle } from 'src/pages/budget/const'
import { useUsers } from 'src/pages/budget/hook'
import { ItemSelectUsers, UiText } from 'src/pages/budget/components'

type FormData = {
  userIds: string[]
}

export const ModalAddUser = () => {
  const modalAddUserStore = useModalAddUserStore()
  const [form] = Form.useForm()
  const { Item } = Descriptions

  const { allUserBudgetMap } = useUsers()
  const { teamMap } = useMap()

  if (!modalAddUserStore) return null

  const open = Boolean(modalAddUserStore)
  const { userIds = [], teamId, type } = modalAddUserStore

  const teamName = teamId && teamMap.get(teamId)?.name

  const excludeIdSet = new Set(userIds)
  const options = [...allUserBudgetMap]
    .filter(([id]) => !excludeIdSet.has(id))
    .map(([value, label]) => ({ value, label }))

  const handleSubmit = (values: FormData) => {
    submitAddUser({ userIds: values.userIds, teamId, type })
    handleCancel()
  }

  const handleCancel = () => {
    form.resetFields()
    closeModalAddUser()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 32 }}>Добавить сотрудников</div>}
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={null}
    >
      <Descriptions
        column={1}
        colon={false}
        styles={{
          label: labelStyle,
          content: { fontSize: 18 },
        }}
      >
        {teamId && <Item label="Команда">{teamName}</Item>}
        <Item label="Доступ">{BUDGET_STEPS[type]}</Item>
      </Descriptions>
      <br />
      <Form layout="vertical" onFinish={handleSubmit} form={form}>
        <ItemSelectUsers
          name="userIds"
          form={form}
          options={options}
          label={
            <UiText size={18} type="secondary">
              Сотрудники
            </UiText>
          }
        />
        <Flex gap={8}>
          <Button style={{ flex: 1 }} size="large" onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            style={{ flex: 1 }}
            size="large"
            type="primary"
            htmlType="submit"
          >
            Сохранить
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
